var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle",class:[
    { 'circle--dark-gray': _vm.task.status == 'available' },
    { 'circle--active': _vm.task.status == 'approved' },
    { 'circle--danger': _vm.task.status == 'revision-needed' },
    { 'circle--warning': _vm.task.status == 'pending-review' },
    { 'circle--exported': _vm.task.status == 'exported' } ]})}
var staticRenderFns = []

export { render, staticRenderFns }